import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
interface MegaMenuProps {
  isOpen: boolean;
  category: string;
}
const megaMenuContent: Record<string, any> = {
  services: {
    title: 'Our Services',
    description: 'Expert commercial HVAC solutions designed for your business.',
    links: [{
      label: 'Installation',
      href: '/services/installation'
    }, {
      label: 'Maintenance',
      href: '/services/maintenance'
    }, {
      label: 'TM44 Compliance',
      href: '/services/tm44'
    }, {
      label: 'Ventilation',
      href: '/services/ventilation'
    }, {
      label: 'All Services',
      href: '/services'
    }],
    cards: [{
      label: 'Ducted Systems',
      image: 'https://cdn.magicpatterns.com/uploads/74DBnnnPaDiHoNeUuZD5vA/ducted-air-conditoning-accutemp.png',
      href: '/services/ducted'
    }, {
      label: 'Cassette Systems',
      image: 'https://cdn.magicpatterns.com/uploads/kUteWPqLmbhAZP4Y92BuJK/cassette-detail.png',
      href: '/services/cassette'
    }, {
      label: 'Wall Mounted',
      image: 'https://cdn.magicpatterns.com/uploads/akgyqHU1pPLUBdVziFo8Cy/wall-mounted-air-conditioning.webp',
      href: '/services/wall-mounted'
    }]
  },
  'why-accutemp': {
    title: 'Why AccuTemp',
    description: 'Discover what makes us the trusted choice for commercial HVAC.',
    links: [{
      label: 'Our Approach',
      href: '/why-accutemp'
    }, {
      label: 'About Us',
      href: '/about'
    }, {
      label: 'Case Studies',
      href: '/case-studies'
    }],
    cards: [{
      label: 'Automotive Industry',
      image: 'https://cdn.magicpatterns.com/uploads/25TP9PqASwBfhD3FYFT9Py/pasted-image.jpg',
      href: '/case-studies/formula-one'
    }, {
      label: 'Subway',
      image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80',
      href: '/case-studies/subway'
    }, {
      label: 'Process Cooling',
      image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80',
      href: '/case-studies/process-cooling'
    }]
  },
  'case-studies': {
    title: 'Case Studies',
    description: 'Real projects, real results from commercial clients across the UK.',
    links: [{
      label: 'All Case Studies',
      href: '/case-studies'
    }, {
      label: 'Automotive Industry',
      href: '/case-studies/formula-one'
    }, {
      label: 'Subway',
      href: '/case-studies/subway'
    }, {
      label: 'Process Cooling',
      href: '/case-studies/process-cooling'
    }],
    cards: [{
      label: 'Manufacturing',
      image: 'https://images.unsplash.com/photo-1581094288338-2314dddb7ece?w=800&q=80',
      href: '/case-studies'
    }, {
      label: 'Retail',
      image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&q=80',
      href: '/case-studies'
    }, {
      label: 'Offices',
      image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80',
      href: '/case-studies'
    }]
  },
  'service-areas': {
    title: 'Service Areas',
    description: 'Commercial HVAC across the Midlands and nationwide.',
    links: [{
      label: 'All Service Areas',
      href: '/service-areas'
    }, {
      label: 'Birmingham',
      href: '/service-areas/birmingham'
    }, {
      label: 'Coventry',
      href: '/service-areas/coventry'
    }, {
      label: 'Solihull',
      href: '/service-areas/solihull'
    }, {
      label: 'Wolverhampton',
      href: '/service-areas/wolverhampton'
    }, {
      label: 'Stoke-on-Trent',
      href: '/service-areas/stoke-on-trent'
    }, {
      label: 'Royal Leamington Spa',
      href: '/service-areas/royal-leamington-spa'
    }],
    cards: [{
      label: 'Birmingham',
      image: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=800&q=80',
      href: '/service-areas/birmingham'
    }, {
      label: 'Coventry',
      image: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=800&q=80',
      href: '/service-areas/coventry'
    }, {
      label: 'Stoke-on-Trent',
      image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80',
      href: '/service-areas/stoke-on-trent'
    }]
  },
  resources: {
    title: 'Resources',
    description: 'Expert guidance and insights for commercial HVAC.',
    links: [{
      label: 'Knowledge Hub',
      href: '/knowledge-hub'
    }, {
      label: 'Compliance',
      href: '/knowledge-hub/compliance'
    }, {
      label: 'Maintenance Guide',
      href: '/knowledge-hub/maintenance-guide'
    }, {
      label: 'Installation Guide',
      href: '/knowledge-hub/installation-guide'
    }, {
      label: 'System Guides',
      href: '/knowledge-hub/system-guides'
    }],
    cards: [{
      label: 'TM44 Compliance',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80',
      href: '/knowledge-hub/compliance'
    }, {
      label: 'Maintenance',
      image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=800&q=80',
      href: '/knowledge-hub/maintenance-guide'
    }, {
      label: 'Installation',
      image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&q=80',
      href: '/knowledge-hub/installation-guide'
    }]
  }
};
export function MegaMenu({
  isOpen,
  category
}: MegaMenuProps) {
  const content = megaMenuContent[category];
  if (!content || !isOpen) return null;
  return <motion.div initial={{
    opacity: 0,
    y: -10
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -10
  }} transition={{
    duration: 0.2
  }} className="absolute left-0 right-0 top-full bg-white shadow-2xl border-t border-gray-100 z-40" data-id="element-285">
      <div className="container mx-auto px-6 py-12" data-id="element-286">
        <div className="grid grid-cols-12 gap-12" data-id="element-287">
          {/* Left Column - Title & Description */}
          <div className="col-span-3" data-id="element-288">
            <h3 className="text-2xl font-bold text-primary-dark mb-3" data-id="element-289">
              {content.title}
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-290">
              {content.description}
            </p>
          </div>

          {/* Middle Column - Links */}
          <div className="col-span-3" data-id="element-291">
            <h4 className="text-xs font-bold uppercase tracking-widest text-primary-dark/40 mb-6" data-id="element-292">
              Explore
            </h4>
            <ul className="space-y-3" data-id="element-293">
              {content.links.map((link: any) => <li key={link.href} data-id="element-294">
                  <Link to={link.href} className="text-primary-dark/80 hover:text-accent transition-colors font-medium flex items-center gap-2 group" data-id="element-295">
                    <span className="w-1 h-1 rounded-full bg-primary-dark/20 group-hover:bg-accent transition-colors" data-id="element-296"></span>
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Right Column - Image Cards */}
          <div className="col-span-6 grid grid-cols-3 gap-4" data-id="element-297">
            {content.cards.map((card: any, idx: number) => <Link key={idx} to={card.href} className="group relative rounded-2xl overflow-hidden aspect-[4/3] bg-surface" data-id="element-298">
                <img src={card.image} alt={card.label} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-299" />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-dark/80 via-primary-dark/20 to-transparent" data-id="element-300"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4" data-id="element-301">
                  <span className="text-white font-bold text-sm" data-id="element-302">
                    {card.label}
                  </span>
                </div>
              </Link>)}
          </div>
        </div>
      </div>
    </motion.div>;
}